/**
 * A Plausible custom event. index.html defines a queueing `window.plausible` stub before Plausible's script loads, so an event sent early is kept; if
 * the script is blocked or absent the call is silent. Never throws. Callers pass only coarse props (a template slug, a step): never an email or a token.
 */
export function track(event: string, props?: Record<string, string>): void {
  try {
    const w = window as unknown as { plausible?: (e: string, o?: { props: Record<string, string> }) => void };
    w.plausible?.(event, props ? { props } : undefined);
  } catch {
    /* analytics never breaks a page */
  }
}
